<template>
  <div class="webphone-page">
    <div class="lv-flex lv-items-center lv-gap-3 lv-mb-4" style="padding: 0.75rem 1rem 0 1.5rem;">
      <div class="lv-p-2 lv-rounded-lg lv-bg-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lv-h-5 lv-w-5"
          style="color: white;">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      </div>
      <div>
        <h1
          class="lv-text-xl lv-font-semibold lv-text-gray-800"
          style="margin: 0;">WebPhone</h1>
        <p
          class="lv-text-sm lv-text-gray-500"
          style="margin: 0;">
          Extensão para navegadores
        </p>
      </div>
    </div>

    <div class="webphone-content">
      <div class="steps">
      <div class="step">
        <div class="step-num">1</div>
        <div class="step-text">
          <h3>Instale a extensão no navegador</h3>
          <p class="lead">
            Adicione o WebPhone ao seu Chrome para falar com mais clientes todos
            os dias.
          </p>
          <a
            class="btn btn-cta"
            :href="extensionUrl"
            target="_blank"
            rel="noopener">
            Instalar no Chrome <span class="arr">→</span>
          </a>
        </div>
        <div class="step-visual">
          <div class="vis vis-extension">
            <img
              src="/static/images/api4com-extension.png"
              alt="WebPhone — faça chamadas para qualquer telefone no seu navegador com apenas um clique">
          </div>
        </div>
      </div>

      <div class="step-conn" />

      <div class="step reverse">
        <div class="step-num">2</div>
        <div class="step-text">
          <h3>Assista ao tutorial</h3>
          <p class="lead">
            Veja como fazer login, configurar o microfone e completar sua primeira
            chamada pelo WebPhone.
          </p>
          <button
            v-if="!videoPlaying"
            type="button"
            class="btn btn-video"
            @click="videoPlaying = true">
            <span class="arr">▶</span> Tocar vídeo
          </button>
        </div>
        <div class="step-visual">
          <div class="vis vis-video">
            <iframe
              v-if="videoPlaying"
              :src="videoEmbedUrl"
              title="Tutorial WebPhone"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen />
            <button
              v-else
              type="button"
              class="video-cover"
              aria-label="Reproduzir vídeo"
              @click="videoPlaying = true">
              <span class="ribbon">Primeiros passos</span>
              <span class="play" />
            </button>
          </div>
        </div>
      </div>

      <div class="step-conn" />

      <div class="step">
        <div class="step-num">3</div>
        <div class="step-text">
          <h3>Siga o guia de instalação</h3>
          <p class="lead">
            Passo a passo completo para instalar a extensão, fazer login e
            deixar o WebPhone pronto para uso.
          </p>
          <a
            class="btn btn-outline"
            :href="articleUrl"
            target="_blank"
            rel="noopener">
            Ler artigo <span class="arr">↗</span>
          </a>
        </div>
        <div class="step-visual">
          <a
            class="vis vis-article"
            :href="articleUrl"
            target="_blank"
            rel="noopener">
            <div class="article-cover">
              <img
                :src="articleImage"
                :alt="articleTitle">
            </div>
            <div class="article-body">
              <span class="article-source">
                <i class="ik ik-help-circle" /> Central de Ajuda · API4COM
              </span>
              <span class="article-title">{{ articleTitle }}</span>
              <p class="article-desc">{{ articleDesc }}</p>
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="support">
      <div class="wa-ic"><i class="ik ik-message-circle" /></div>
      <div class="support-txt">
        <h4>Ficou com alguma dúvida?</h4>
      </div>
      <a
        class="btn btn-wa"
        :href="supportUrl"
        target="_blank"
        rel="noopener">
        Falar no WhatsApp <span class="arr">↗</span>
      </a>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Webphone',
  data: () => ({
    videoPlaying: false,
    extensionUrl: 'https://chromewebstore.google.com/detail/webphone-api4com/ccahjcilejbllkkgngikflblpgojjdaa?hl=pt-BR',
    videoEmbedUrl: 'https://www.youtube.com/embed/ikOeI00pDGw?start=58&autoplay=1',
    articleUrl: 'https://ajuda.sacflow.io/api4com/articles/280-como-instalar-o-webphone-',
    articleTitle: 'Como instalar o WebPhone',
    articleDesc: 'Passo a passo de como instalar a extensão do WebPhone: abrir o WebPhone no sistema, baixar a extensão no Chrome e fazer login para começar a ligar.',
    articleImage: '/static/images/webphone-article-280.png',
    supportUrl: 'https://wa.me/554833328503'
  })
}
</script>

<style lang="scss" scoped>
$brand-dark: #2b3a3a;
$brand-orange: #f5a623;
$brand-orange-2: #e09313;
$brand-blue: #2c8cdc;
$brand-green: #25d366;
$ink: #1d2424;
$ink-soft: #59605f;
$line: #e2e0da;
$gray-200: #e5e7eb;
$gray-300: #d1d5db;
$gray-500: #6b7280;
$gray-800: #1f2937;

.webphone-page {
  color: $ink;
}

.webphone-content {
  padding: 0.5rem 1.5rem 1.5rem;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.step {
  display: grid;
  grid-template-columns: 56px 1fr 1.1fr;
  gap: 24px;
  align-items: center;
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  padding: 20px 24px;
}
.step.reverse {
  grid-template-columns: 56px 1.1fr 1fr;
  .step-text { order: 3; }
  .step-visual { order: 2; }
}
.step-num {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: $brand-blue;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
.step-text {
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: $gray-800;
    margin: 0 0 6px;
  }
  .lead {
    font-size: 14px;
    line-height: 1.55;
    color: $gray-500;
    margin: 0 0 16px;
  }
}
.step-visual {
  background: transparent;
}

.step-conn {
  width: 0;
  height: 16px;
  margin-left: 46px;
  border-left: 2px dashed $gray-300;
}

.vis {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid $gray-200;
}
.vis-extension {
  aspect-ratio: 16 / 9;
  background: #29a3e3;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}
.vis-video {
  position: relative;
  aspect-ratio: 16 / 9;
  background: $brand-dark;
  iframe { width: 100%; height: 100%; display: block; border: 0; }
}
.video-cover {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  cursor: pointer;
  display: grid;
  place-items: center;
  background:
    radial-gradient(circle at 75% 65%, rgba(44, 140, 220, 0.18) 0 60px, transparent 61px),
    linear-gradient(135deg, #1d2929, #2b3a3a);
  .play {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: $brand-blue;
    border: 2px solid #fff;
    box-shadow: 0 0 0 6px rgba(44, 140, 220, 0.25);
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 54%;
      transform: translate(-50%, -50%);
      border-left: 18px solid #fff;
      border-top: 11px solid transparent;
      border-bottom: 11px solid transparent;
    }
  }
  .ribbon {
    position: absolute;
    top: 10px;
    left: 10px;
    background: rgba(0, 0, 0, 0.55);
    color: #fff;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 4px;
  }
}
.vis-article {
  display: block;
  background: #fff;
  border: 1px solid $gray-200;
  text-decoration: none;
  color: $gray-800;
  transition: box-shadow 0.15s ease;
  &:hover {
    text-decoration: none;
    color: $gray-800;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    .article-title { color: $brand-blue; }
  }
  .article-cover {
    aspect-ratio: 16 / 9;
    background: $brand-blue;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .article-body {
    padding: 14px 16px 16px;
  }
  .article-source {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: $brand-blue;
    margin-bottom: 6px;
  }
  .article-title {
    display: block;
    font-weight: 600;
    font-size: 15px;
    line-height: 1.3;
    color: $gray-800;
    margin-bottom: 6px;
  }
  .article-desc {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: $gray-500;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  text-decoration: none;
  transition: filter 0.15s ease, transform 0.05s ease;
  &:hover { filter: brightness(0.96); text-decoration: none; }
  &:active { transform: translateY(1px); }
  .arr { font-weight: 700; }
}
.btn-cta { background: $brand-blue; color: #fff; }
.btn-video { background: $brand-blue; color: #fff; }
.btn-outline {
  background: $brand-blue;
  color: #fff;
  border-color: $brand-blue;
}
.btn-wa { background: $brand-green; color: #07300f; }

.support {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 22px;
  background: #fff;
  border: 1px solid $gray-200;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  .wa-ic {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: $brand-green;
    color: #07300f;
    font-size: 22px;
    flex: 0 0 44px;
  }
  .support-txt {
    flex: 1;
    h4 { margin: 0 0 2px; font-size: 15px; font-weight: 600; color: $gray-800; }
    p { margin: 0; font-size: 13px; color: $gray-500; }
  }
}

@media (max-width: 768px) {
  .step,
  .step.reverse {
    grid-template-columns: 44px 1fr;
  }
  .step-visual { grid-column: 1 / -1; }
  .step.reverse {
    .step-text { order: 2; }
    .step-visual { order: 3; }
  }
  .support { flex-wrap: wrap; }
}
</style>



// WEBPACK FOOTER //
// src/components/Webphone/Index.vue